import type { Components } from '@mui/material';

export const MuiPaper: Components['MuiPaper'] = {
  styleOverrides: {
    outlined: {
      padding: '42px 32px',
      borderRadius: '6px',
      border: '1px solid #dfebf1',
      boxShadow: '0px 10px 24px 0px rgba(0, 0, 0, 0.03)',
    },
  },
};